import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import CloseIcon from "assets/svgs/close-btn.svg";
import RichText from "components/rich-text";
import * as styles from "./style.mod.scss";
import WhiteArrowRight from "assets/svgs/white-right-arrow.svg";
import { loadRecaptcha } from "helpers/load-recaptcha";
import locale from "locales";
import BlueArrowRight from "assets/images/icons/blue-transparent.svg";

const BlockCheckoutModal = ({
  title, description,
  klaviyoId, successMessage,
  open, hideModal,
}) => {
  const [disabled, setDisabled] = useState(false);
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubscribe = (e) => {
    if (email === "") return;
    setDisabled(true);
    window.grecaptcha.ready(async function () {
      await window.grecaptcha.execute(process.env.GATSBY_RECAPTCHA_SITE_KEY, { action: "submit" });

      const response = await fetch("/.netlify/functions/klaviyo",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: email,
            listId: klaviyoId
          })
        }
      );

      if (response?.status === 204) {
        setEmail("");
        setSuccess(true);
      }
      setDisabled(false);
    });
    e.preventDefault();
  };
  return (

    <Modal show={open} onHide={hideModal} className={`${styles.modal} ${styles.blockCheckoutModal}`}>
      <CloseIcon className={`${styles.modalClose} ${styles.modalCloseDesktop}`} onClick={hideModal} />
      <Modal.Body>
        <div className={styles.modalContainer}>
          {title && <h1 className={styles.modalTitle}>{title}</h1>}
          {
            description && (
              <div className={styles.modalDescription}>
                <RichText
                  blocks={description}
                />
              </div>  
            )
          }
          <div className={styles.subscribeContainer}>
            {
              success ?
                <div className={styles.success}>
                  <img src={BlueArrowRight} alt="blue tick" />
                  {successMessage && <p>{successMessage}</p>}
                </div> :
                <form onSubmit={handleSubscribe}>
                  <input type="email" placeholder="E-MAIL" required value={email} onFocus={loadRecaptcha} onChange={(e) => setEmail(e.target.value)} />
                  <button type="submit" disabled={disabled}><WhiteArrowRight /></button>
                </form>
            }
            <button onClick={hideModal} className={styles.continueShopping}>{locale.cart.blockCheckoutModalBtn}</button>
          </div>
        </div>
      </Modal.Body>
      <div className={styles.modalCloseContainer}>
        <CloseIcon className={`${styles.modalClose} ${styles.modalCloseResponsive}`} onClick={hideModal} />
      </div>
    </Modal>
  );
};

export default BlockCheckoutModal;